package net.sparklypower.website.frontend

import js.array.asList
import kotlinx.serialization.json.Json
import net.perfectdreams.luna.bliss.Bliss
import net.perfectdreams.luna.bliss.BlissHex
import net.perfectdreams.luna.toasts.EmbeddedToast
import net.perfectdreams.luna.toasts.ToastManager
import web.dom.document
import web.html.HTMLElement

class SparklyWebsiteFrontend {
    val toastManager = ToastManager({}) {}

    fun start() {
        Bliss.setupEvents()
        Bliss.processAttributes(document.body)

        toastManager.render(document.querySelector("#toast-list") as HTMLElement)

        Bliss.registerDocumentParsedEventListener { parsedDocument ->
            val showToastHack = parsedDocument.querySelectorAll("[bliss-show-toast]")
            for (element in showToastHack.asList()) {
                val content = element.getAttribute("bliss-toast") ?: error("Missing bliss-toast attribute on a bliss-show-toast!")
                val toast = Json.decodeFromString<EmbeddedToast>(BlissHex.decodeFromHexString(content))
                element.remove()

                this.toastManager.showToast(toast)
            }
        }
    }
}